import React, { useState, useEffect, Fragment } from 'react';
import { Drawer, IconButton, Tabs, Tab, Box } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import './style.scss';
import InteractionContent from './InteractionContent';
import { DrawerContent, DrawerTabs } from './InteractionDrawer.types';
import useMediaQuery from 'pctHooks/useMediaQuery';
import useModalOverflowHidden from 'pctHooks/useModalOverflowHidden';

import {  getLevelNodeEnrollment } from '../../../services/api';

type Props = {
    isOpen: boolean;
    handleClose: () => void;
    enabledTabs: boolean;
    tabs: DrawerTabs[];
    contents: DrawerContent[];
    configHeaderFooter?: any;
};

const InteractionDrawer = ({
    handleClose,
    isOpen = false,
    enabledTabs = false,
    tabs = [],
    contents = [],
    configHeaderFooter = null,
}: Props) => {
    const isMobile = useMediaQuery('md');
    const [selectedTab, setSelectedTab] = useState(0);

    const [commentDataEnrollment, setCommentDataEnrollment] = useState<any>(null);
    
    
    const toggleSidebar = () => {
        handleClose();
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    
    useModalOverflowHidden({ visible: isOpen });


    const enrollmentsConfiguration = async (dataEnrollment) => {
        if (dataEnrollment) {
            const { data } = await getLevelNodeEnrollment(dataEnrollment.idUser, dataEnrollment.idEnrollment);

            const mandatoryCommentsCount = data?.node?.nodeEnrollment?.enrollment.mandatoryCommentsCount;
            const commentMinCount = data?.node?.nodeEnrollment?.team?.configuration?.commentMinCount;
            
            const commentsProgressInfo =
                String(mandatoryCommentsCount <= commentMinCount ? mandatoryCommentsCount : commentMinCount) +
                '/' +
                String(commentMinCount);
            const commentsProgress = (mandatoryCommentsCount/commentMinCount)*100;
            const commentsProgressStatus =
                commentsProgress >= 100
                    ? 'Completo'
                    : commentsProgress > 0 && commentsProgress < 100
                    ? 'Em andamento'
                    : 'Não iniciado';

            setCommentDataEnrollment({
                ...data?.node?.nodeEnrollment?.team?.configuration,
                ...data?.node?.nodeEnrollment?.enrollment,
                commentsProgressInfo: commentsProgressInfo,
                commentsProgress: commentsProgress < 100 ? commentsProgress : 100,
                commentsProgressStatus: commentsProgressStatus,
            });
        }
    };


    useEffect(() => {
        if (!configHeaderFooter) return;

        let dataEnrollment: { idEnrollment?: string; idUser?: string } | null = null;

        const nodeEnrollment = configHeaderFooter.nodeCollection?.node?.nodeEnrollment?.enrollment;
        const contentEnrollment = configHeaderFooter.single && configHeaderFooter.contentNavigation?.contentEnrollment;

        if (nodeEnrollment) {
            dataEnrollment = {
                idEnrollment: nodeEnrollment.idEnrollment,
                idUser: nodeEnrollment.idUser,
            };
        } else if (contentEnrollment) {
            dataEnrollment = {
                idEnrollment: contentEnrollment.idEnrollment,
                idUser: contentEnrollment.idUser,
            };
        }

        if (dataEnrollment) {
            enrollmentsConfiguration(dataEnrollment);
        }
    }, []);

    

    return (
        <>
            <Drawer anchor="right" open={isOpen} onClose={toggleSidebar}>
                <div
                    className="interaction-drawer-container"
                    style={{ width: isMobile ? '100vw' : '50vw', minWidth: isMobile ? 'auto' : '800px' }}
                    role="presentation"
                >
                    <div
                        className={`${isMobile ? 'interaction-drawer-header-mobile' : ''} ${
                            enabledTabs ? 'enabled-tabs' : ''
                        }`}
                    >
                        {isMobile && <p>{tabs[selectedTab]?.title}</p>}
                        <IconButton
                            onClick={toggleSidebar}
                            className={`interaction-drawer-close-button right-align${isMobile ? 'mobile' : ''}`}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <>
                        {enabledTabs && (
                            <>
                                <Tabs
                                    value={selectedTab}
                                    onChange={handleTabChange}
                                    aria-label="interaction tabs"
                                    className="interaction-tabs"
                                    textColor="inherit"
                                    classes={{
                                        indicator: 'interaction-tab-indicator',
                                    }}
                                    variant="fullWidth"
                                >
                                    {tabs.map((tab, indice) => (
                                        <Tab
                                            key={indice}
                                            label={!isMobile ? tab.label : tab.icon}
                                            className="interaction-tab"
                                            style={{ flex: 1 }}
                                        />
                                    ))}
                                </Tabs>
                            </>
                        )}

                        {contents.map((content, index) => (
                            <Fragment key={index}>
                                {!isMobile && !enabledTabs && (
                                    <p className="interaction-drawer-header">{content.title}</p>
                                )}
                                <Box
                                    role="tabpanel"
                                    hidden={selectedTab !== index}
                                    className={`tab-content${isMobile ? 'mobile' : ''}`}
                                >
                                    <InteractionContent
                                        entityType={content.entityType}
                                        idEntity={content.idEntity}
                                        commentDataEnrollment={commentDataEnrollment}
                                        handleEnrollmentsConfiguration={enrollmentsConfiguration}
                                    />
                                </Box>
                            </Fragment>
                        ))}
                    </>
                </div>
            </Drawer>
        </>
    );
};

export default InteractionDrawer;
